// extracted by mini-css-extract-plugin
export var infoSection = "_s-1";
export var infoSectionContainer = "_s-0";
export var infoSectionTitleRow = "_s-2";
export var multiLineInfo = "_s-4";
export var strong = "_s-3";